import CloseIcon from '@mui/icons-material/Close'
import ReportIcon from '@mui/icons-material/Report'
import ThumbUpIcon from '@mui/icons-material/ThumbUpOutlined'
import Box from '@mui/material/Box'
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import { IconBox } from '~/components/Atoms/IconBox'

export function Toast({ state, ...props }: { state: 'error' | 'success' } & SnackbarProps) {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      {...props}
      sx={{
        backgroundColor: state === 'error' ? theme.palette.error.light : theme.palette.success.light,
        borderRadius: `${theme.radius.M} 0 0 ${theme.radius.M}`,
        '&.MuiSnackbar-root': { right: 0 },
      }}
    >
      <Box display="flex" padding={theme.spacing.L} width="360px" alignItems="center" gap={theme.spacing.L}>
        <IconBox
          bgcolor={state === 'error' ? theme.palette.error.main : theme.palette.success.main}
          icon={state === 'error' ? <ReportIcon /> : <ThumbUpIcon />}
        />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          color={state === 'error' ? theme.palette.text.inverse : theme.palette.success.dark}
        >
          <Box display="flex" flexDirection="column">
            <Typography variant="body">{t(`common:toast.${state}`)}</Typography>
            <Typography variant="body-small">{props.message}</Typography>
          </Box>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={(e) => props.onClose && props.onClose(e, 'escapeKeyDown')} />
        </Box>
      </Box>
    </Snackbar>
  )
}
